export const EMPTY_STRING = '';

export const EMPTY_OBJECT = Object.freeze({});

export const EMPTY_ARRAY = Object.freeze<readonly never[]>([]);

export const NULL_FUNCTION = () => null;

export const TEMPORARY_STRING = '■';
